import { arrow } from "@popperjs/core";
import "scriptsPath/slick/slick.css";

import(/* webpackChunkName: "slick" */ "scriptsPath/slick/slick").then(() => {
	//applications subpages slider
	(function initSingleSlick() {
		if ($(".slider-sar").length) {
			const $progressBar = $(".progress");

			function initResponsiveSlider() {
				const $slider = $(".slider-sar");

				if ($(window).width() <= 992) {
					if (!$slider.hasClass("slick-initialized")) {
						$slider.on("beforeChange", function (event, slick, currentSlide, nextSlide) {
							var calc = (nextSlide / (slick.slideCount - 1)) * 100;

							$progressBar.css("background-size", calc + "% 100%").attr("aria-valuenow", calc);
						});

						$slider.slick({
							dots: true,
							infinite: false,
							slidesToShow: 1.2,
							slidesToScroll: 1,
							lazyLoad: "ondemand",
							arrows: false,
						});
					}
				} else {
					if ($slider.hasClass("slick-initialized")) {
						$slider.slick("unslick");
					}
				}
			}

			$(window).on("load resize", function () {
				initResponsiveSlider();
			});
		}
	})();
});
